import call1 from "../../assets/images/call1.webp";
import send from "../../assets/images/send.svg";

import start_rating from "../../assets/images/start_rating.webp";
import user_switch from "../../assets/images/user_switch.svg";
import arrow_up from "../../assets/images/arrow_up.svg";
import crown from "../../assets/images/crown.svg";
import banner_lg from "../../assets/images/banner_lg.webp";
import bannerlg from "../../assets/images/bannerlg.webp";
import bannermo from "../../assets/images/bannermo.webp";
export default function Banner() {
  return (
    <div
      className="w-full bg-center bg-cover bg-no-repeat"
      style={{
        backgroundImage: `url(${
          window.innerWidth < 768 ? bannermo : bannerlg
        })`,
      }}
    >
      <div className=" w-full mx-auto  p-3 bg-cover bg-center bg-no-repeat container mt-20 lg:mt-[104px]  ">
        <div className="p-1 grid grid-cols-1 gap-4 items-center glg:grid-cols-2 w-full lg:px-6">
          <div className=" h-auto flex flex-col gap-4 lg:gap-6 p-2 text-white relative lg:left-[70px]">
            <div>
              <p className="text-[16px] font-semibold text-center lg:text-start lg:text-[26px] ">
                CHÀO MỪNG BẠN ĐẾN VỚI BLUESKYIT
              </p>
            </div>
            <div className="text-center lg:text-start text-[1.4rem] font-medium leading-[2.25rem] lg:text-[2rem] lg:font-medium">
              <p>BlueskyIT – Kết nối giải pháp cho tương lai</p>
            </div>
            <div className="lg:text-[16px] lg:font-normal text-center lg:text-start text-[24px] font-semibold leading-[1.75rem] ">
              <p>
                Chúng tôi cung cấp những giải pháp đột phá trong giáo dục, sức
                khỏe và đào tạo
              </p>
            </div>
            <div className="flex flex-col items-center lg:flex-row md:items-center justify-center gap-4">
              <div className="flex items-center w-full justify-center lg:justify-start">
                <div>
                  <a href="contact-us">
                    <button className=" bg-white border border-white flex items-center shadow-custom rounded-[30px] gap-3 justify-center w-72 h-12 ">
                      <img src={call1} alt="call1" />
                      <p className="text-[#1375b7] font-medium text-[1.125rem]">
                        Liên hệ tư vấn ngay
                      </p>
                    </button>
                  </a>
                </div>

                <div className="border border-white w-[48px] h-[48px] bg-white flex items-center justify-center rounded-full ml-0.5 ">
                  <img src={send} alt="send" />
                </div>
              </div>

              <div className="flex flex-col w-full justify-center lg:flex-col lg:items-start lg:text-left lg:gap-2 items-center">
                <img src={start_rating} alt="rate" className="w-28" />
                <p className="text-[0.8rem] font-normal">
                  2960+ đánh giá từ khách hàng
                </p>
              </div>
            </div>
          </div>

          {/* banner2 */}

          <div className="relative flex flex-col  items-center gap-4  lg:bottom-[-4px] lg:left-[110px]">
            {/*  */}

            <div className="flex items-center justify-around shadow-custom1 w-[22rem] h-[59px] p-2 lg:absolute lg:bottom-[245px] lg:-left-[-30px] bg-white rounded-[36px] lg:w-[14.8125rem] lg:z-20 animate-bounce ">
              <div className="flex lg:items-start justify-center flex-col ">
                <p className="text-[#073C7A] text-[1.5rem] font-normal lg:font-semibold  left-[60px]">
                  68K+
                </p>
                <p className="text-[0.875rem] font-normal text-[#333]">
                  Khách hàng hài lòng
                </p>
              </div>
              <div className="bg-[#3DB72D] w-[3rem] h-[3rem] left-[26px] flex items-center justify-center rounded-full ">
                <img src={user_switch} alt="user" />
              </div>
            </div>
            {/*  */}
            {/*  */}

            {/*  */}
            {/*  */}
            <div className="flex items-center justify-around shadow-custom1 lg:absolute lg:bottom-[40px] lg:right-[270px] p-2 w-[270px] h-[57px] bg-white rounded-[36px] lg:w-[15.8125rem] lg:z-20 animate-bounce ">
              <div className="bg-[#4CA8FF] w-[3rem] h-[3rem] flex items-center justify-center rounded-full right-[23px] ">
                <img src={crown} alt="crown" />
              </div>
              <div className="flex items-center justify-center flex-col gap-1  right-[52px]">
                <p className="text-[#073C7A] text-[0.875rem] font-normal">
                  Giá trị doanh nghiệp
                </p>
                <p className="text-[1.5rem] font-normal text-[#073C7A] flex lg:font-semibold">
                  1.000.000${" "}
                  <img
                    src={arrow_up}
                    alt="arrow_up"
                    className="animate-bounce"
                  />
                </p>
              </div>
            </div>

            <div className="flex items-center justify-center shadow-custom1 w-[170px] lg:absolute lg:bottom-[160px] lg:-right-[-85px] h-[57px] px-[24px] py-[8px] bg-white rounded-[36px] lg:z-20 lg:w-[10.1875rem] animate-bounce ">
              <div className="flex items-center justify-center flex-col w-full">
                <p className="text-[0.875rem] font-normal text-[#333]">
                  Tỉ lệ thành công
                </p>
                <p className=" text-[#073C7A] text-[1.5rem] font-normal lg:font-semibold">
                  96%
                </p>
              </div>
            </div>
            <div>
              <img
                src={banner_lg}
                alt="ban"
                className="max-w-full h-auto relative bottom-[20px] lg:max-w-full lg:w-[333.965px] lg:h-[415.894px] "
              />
            </div>
            {/*  */}
          </div>

          {/* banner2 */}
        </div>
      </div>
    </div>
  );
}
